import Axios from 'axios';

const cancelToken = Axios.CancelToken.source();

const getBaseURL = () => {
    if (process.env.NODE_ENV === 'production') {
      return 'https://kitcontact.in/api'; // Replace with your production URL
    }
    return 'http://localhost:8084/Product/KiTReact/api';
  };

const initialBaseURL = getBaseURL();
if (!localStorage.getItem('baseURL')) {
  localStorage.setItem('baseURL', initialBaseURL);
}

const axios = Axios.create({
  baseURL: localStorage.getItem('baseURL') || initialBaseURL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-CSRF-TOKEN': localStorage.getItem('token'),
    //'Access-Control-Allow-Origin': 'https://kitcontact.in, https://*.kitcontact.in,http://kitcontact.in, http://*.kitcontact.in,  http://localhost:3000,http://localhost:8084/Product/KiTReact,http://*.localhost:8084/Product/KiTReact',
    //'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
    //'Access-Control-Allow-Headers': '*',

    //'Access-Control-Allow-Credentials':true
  },
  cancelToken: cancelToken.token
});
if (localStorage.getItem('token') === '' || localStorage.getItem('token') === null) {
  axios
    .get(`${axios.defaults.baseURL}/csrf-token`)
    .then((response) => {
      const csrfToken = response.data.csrf_token;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
      localStorage.setItem('token', csrfToken);
    })
    .catch((error) => {
      console.error('Error fetching CSRF token:', error);
    });
}

export default axios;
